module.exports = __webpack_public_path__ + "img/logo.84a8686d.jpg";